<template>
  <section>
<hlx-signature
:input-val="'SignatureComponent'"
></hlx-signature>
  </section>
</template>

<script>
// import SignatureComponent from "../components/SignatureComponent.vue";
import HlxSignature from "../components/SignatureComponent.vue"
export default {
components:{
    HlxSignature 
},
data(){
    return{

    }
}
}
</script>

<style>

</style>